export const trimFormatter = (inputValue = ''): string => inputValue.trim();
